/** Complete encoded transactions; content and transport envelopes have separate budgets. */
export const flashcardsReplicationBudgets = {
  transactionBytes: 8 * 1024 * 1024,
  requestBytes: 8 * 1024 * 1024 + 64 * 1024,
  responseBytes: 8 * 1024 * 1024 + 64 * 1024,
} as const
